import { inject } from '@angular/core';
import { Routes } from '@angular/router';

import { authGuard } from '@core/auth/guards/auth.guard';
import { LayoutBlankComponent } from '@core/layouts/layout-blank/layout-blank.component';
import { LayoutDefaultComponent } from '@core/layouts/layout-default/layout-default.component';
import { LayoutLandingComponent } from '@core/layouts/layout-landing/layout-landing.component';

export enum USER_TYPE_PERMISSION {
  'WPN' = 'WPN',
  'WPN_BRANCH' = 'WPN_BRANCH',
  'FRANCHISE' = 'FRANCHISE',
  'FRANCHISE_BRANCH' = 'FRANCHISE_BRANCH'
}

export const routes: Routes = [
  {
    path: "",
    redirectTo: () => {
      return "welcome";
      // const storage = inject(CoreStorageService);
      // const accessToken = storage.getItem('access_token');
      // return !accessToken ? '/auth/login' : '/home'
    },
    pathMatch: "full",
  },
  {
    path: "auth",
    component: LayoutBlankComponent,
    loadChildren: () => import("./core/auth/auth.routes").then((r) => r.routes),
  },
  {
    path: "welcome",
    component: LayoutLandingComponent,
    canActivate: [authGuard],
    loadChildren: () => import("./features/landing/landing.routes").then((r) => r.routes),
  },

  {
    path: "manage-accounts",
    component: LayoutLandingComponent,
    canActivate: [authGuard],
    loadChildren: () => import("./features/manage-accounts/manage-accounts.routes").then((r) => r.routes),
  },

  // WPN
  {
    path: "",
    component: LayoutDefaultComponent,
    canActivate: [authGuard],
    data: { breadcrumb: "" },
    children: [
      {
        path: "home",
        loadChildren: () => import("./features/storyboard/storyboard.routes").then((r) => r.routes),
        data: { breadcrumb: "" },
      },
      {
        path: "storyboard",
        loadChildren: () => import("./features/storyboard/storyboard.routes").then((r) => r.routes),
        data: { breadcrumb: "Storyboard" },
      },
      {
        path: "customer",
        loadChildren: () => import("./features/customer/customer.routes").then((r) => r.routes),
        data: { breadcrumb: "Customer" },
      },
      {
        path: "uikit",
        loadChildren: () => import("./features/temp/temp.routes").then((r) => r.routes),
        data: { breadcrumb: "UI Kit" },
      },
      {
        path: "member",
        loadChildren: () => import("./features/member/member.routes").then((r) => r.routes),
        data: { breadcrumb: "member" },
      },
      {
        path: "unit",
        loadChildren: () => import("./features/unit/unit.routes").then((r) => r.routes),
        data: { breadcrumb: "countingUnit" },
      },
      {
        path: "product-category",
        loadChildren: () => import("./features/product-category/product-category.routes").then((r) => r.routes),
        data: { breadcrumb: "productCategory" },
      },
      {
        path: "product",
        loadChildren: () => import("./features/product/product.routes").then((r) => r.routes),
        data: { breadcrumb: "productsForPurchase" },
      },
      {
        path: "set-up-wallpaper",
        loadChildren: () => import("./features/set-up-wallpaper/set-up-wallpaper.routes").then((r) => r.routes),
        data: { breadcrumb: "Set Up Wallpaper" },
      },
      {
        path: "franchise",
        loadChildren: () => import("./features/franchise/franchise.routes").then((r) => r.routes),
        data: { breadcrumb: "franchise" },
      },
      {
        path: "license-franchise",
        loadChildren: () => import("./features/license-franchise/license-franchise.routes").then((r) => r.routes),
        data: { breadcrumb: "licenseFranchise" },
      },
      {
        path: "branch-wpn",
        loadChildren: () => import("./features/branch-wpn/branch-wpn.routes").then((r) => r.routes),
        data: { breadcrumb: "branchWpn" },
      },
      {
        path: "member-tier",
        loadChildren: () => import("./features/member-tier/member-tier.routes").then((r) => r.routes),
        data: { breadcrumb: "memberTier.memberTierTitle" },
      },
      {
        path: "terms-and-condition",
        loadChildren: () => import("./features/terms-and-condition/terms-and-condition.routes").then((r) => r.routes),
        data: { breadcrumb: "termAndConRegistration.title" },
      },
      {
        path: "purchase",
        loadChildren: () => import("./features/purchase/purchase.routes").then((r) => r.routes),
        data: { breadcrumb: "purchaseList" },
      },
      {
        path: "bulk-loading",
        loadChildren: () => import("./features/bulk-loading/bulk-loading.routes").then((r) => r.routes),
        data: { breadcrumb: "weighing.weighingTitle" },
      },

      {
        path: "bank",
        loadChildren: () => import("./features/bank/bank.routes").then((r) => r.routes),
        data: { breadcrumb: "bank" },
      },
      {
        path: "middle-price",
        loadChildren: () => import("./features/middle-price/middle-price.routes").then((r) => r.routes),
        data: { breadcrumb: "middlePrice.title" },
      },
      {
        path: "role",
        loadChildren: () => import("./features/user-role-management/user-role-management.routes").then((r) => r.routes),
        data: { breadcrumb: "userManagement.rolePermission" },
      },
      {
        path: "user",
        loadChildren: () => import("./features/user-management/user-management.routes").then((r) => r.routes),
        data: { breadcrumb: "userManagement.userAccount" },
      },
      {
        path: "miscellaneous-products",
        loadChildren: () => import("./features/miscellaneous-products/miscellaneous-products.routes").then((r) => r.routes),
        data: { breadcrumb: "miscellaneousProducts" },
      },

      {
        path: "franchise-tier",
        loadChildren: () => import("./features/franchise-tier/franchise-tier.routes").then((r) => r.routes),
        data: { breadcrumb: "franchiseTier.franchiseTierTitle" },
      },

      {
        path: "purchase-price",
        loadChildren: () => import("./features/purchase-price/purchase-price.routes").then((r) => r.routes),
        data: { breadcrumb: "purchasePrice.title" },
      },
    ],
  },

  {
    path: "report",
    component: LayoutDefaultComponent,
    canActivate: [authGuard],
    data: { breadcrumb: "" },
    children: [
      {
        path: "report-purchase",
        loadChildren: () => import("./features/report-purchase/report-purchase.routes").then((r) => r.routes),
        data: { breadcrumb: "report.reportPurchased" },
      },
      {
        path: "report-bulk-loading",
        loadChildren: () => import("./features/report-bulk-loading/report-bulk-loading.routes").then((r) => r.routes),
        data: {
          breadcrumb: "weighing.reportWeighingTitle",
        },
      },
      {
        path: "report-register-member",
        loadChildren: () => import("./features/report-register-member/report-register-member.routes").then((r) => r.routes),
        data: { breadcrumb: "report.reportRegisterMember" },
      },
      {
        path: "report-register-franchise",
        loadChildren: () => import("./features/report-register-franchise/report-register-franchise.routes").then((r) => r.routes),
        data: { breadcrumb: "report.reportRegisterFranchise" },
      },
      {
        path: "report-active-members-and-franchise",
        loadChildren: () => import("./features/report-active-members-and-franchise/report-active-members-and-franchise.routes").then((r) => r.routes),
        data: { breadcrumb: "report.listOfActiveMembersFranchises" },
      },
      {
        path: "report-inventory",
        loadChildren: () => import("./features/report-inventory/report-inventory.routes").then((r) => r.routes),
      },
    ],
  },

  {
    path: "",
    component: LayoutDefaultComponent,
    canActivate: [authGuard],
    data: { breadcrumb: "" },
    children: [
      {
        path: ":locationId/purchase-price",
        loadChildren: () => import("./features/purchase-price/purchase-price.routes").then((r) => r.routes),
        data: { breadcrumb: "purchasePrice.title" },
      },
      {
        path: ":locationId/purchase",
        loadChildren: () => import("./features/purchase/purchase.routes").then((r) => r.routes),
        data: { breadcrumb: "purchaseList" },
      },
      {
        path: ":locationId/bulk-loading",
        loadChildren: () => import("./features/bulk-loading/bulk-loading.routes").then((r) => r.routes),
        data: { breadcrumb: "weighing.weighingTitle" },
      },
    ],
  },
];
